import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { scrollIntoView } from "utils/helper";
import CvInformation from "./cvInformation";
import EditCvInformation from "./editCvInformation";
import UseCvInformation from "./useCvInformation";
import { resumeType } from "utils/constantValues";
import { convertToHumanDateTime } from "utils/DateHelper";

function Index({ isShowEditIcon }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { isLoading, onEditResume, fileName, setFileName } = UseCvInformation();

  const userDetails = useSelector((state) => state.userDetails || {});
  const cvData =
    userDetails?.userFiles?.find((file) => file.type === resumeType) || {};
  const handleEditClick = () => {
    setIsEditMode(true);
  };
  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("personalDetailsScrollId");
  };

  const handleSave = async (values) => {
    const updatedResume = values.resume?.id
      ? values.resume
      : {
          id: values.resume,
          name: fileName,
          type: resumeType,
          createdAt: convertToHumanDateTime(new Date(), "YYYY-MM-DD"),
          updatedAt: convertToHumanDateTime(new Date(), "YYYY-MM-DD"),
        };

    await onEditResume({ resume: updatedResume });
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditCvInformation
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isLoading}
        setFileName={setFileName}
      />
    );
  }

  return (
    <CvInformation
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
      cvData={cvData}
    />
  );
}

export default Index;
Index.propTypes = {
  isShowEditIcon: PropTypes.bool,
};
